<template>
  <div class="navbar-wrapper">
    <b-navbar toggleable="lg" type="light" variant="light" fixed="top" class="modern-navbar">
      <b-container>
        <router-link to="/" class="brand navbar-brand">
          <div class="brand-mark">JT</div>
          <div class="brand-text-container">
            <span class="brand-text">Jens Trompler</span>
            <span class="brand-subtitle">IT Consulting · Digitalisierung · Delivery</span>
          </div>
        </router-link>
        <b-navbar-toggle target="nav-collapse" class="ml-auto"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav class="ml-auto">
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/#portfolio">Leistungen</b-nav-item>
            <b-nav-item to="/#devops">DevOps & PM</b-nav-item>
            <b-nav-item to="/#model">Arbeitsweise</b-nav-item>
            <b-nav-item to="/#origin">Erfahrung</b-nav-item>
            <b-nav-item to="/#about">Profil</b-nav-item>
            <b-nav-item to="/impressum">Impressum</b-nav-item>
          </b-navbar-nav>
          <div class="nav-cta d-none d-lg-block">
            <router-link to="/kontakt" class="contact-button">Kontakt</router-link>
          </div>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'AppNavbar',
};
</script>

<style lang="scss" scoped>
@use "@/assets/css/global.scss" as *;

.navbar-wrapper {
  position: absolute;
  width: 100%;
  z-index: 1000;
}

.modern-navbar {
  background: rgba(255, 252, 248, 0.88) !important;
  backdrop-filter: blur(16px);
  padding: 1rem 0;
  transition: all 0.3s ease;
  border-bottom: 1px solid $line-color;
  box-shadow: 0 8px 24px rgba(24, 35, 47, 0.06);
  
  &.scrolled {
    padding: 0.5rem 0;
    background: rgba(255, 252, 248, 0.96) !important;
    box-shadow: 0 12px 28px rgba(24, 35, 47, 0.08);
  }
}

.brand {
  display: flex;
  align-items: center;
  line-height: 1.2;
  text-decoration: none;
  
  &:hover {
    text-decoration: none;
  }
  
  .logo-container {
    margin-right: 10px;
    
    .logo-svg {
      transition: transform 0.3s ease;
    }
    
    &:hover .logo-svg {
      transform: rotate(10deg);
    }
  }
  
  .brand-text-container {
    display: flex;
    flex-direction: column;
  }
  
  .brand-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    margin-right: 12px;
    border-radius: 12px;
    background: $accent-color;
    color: #ffffff;
    font-size: 0.95rem;
    font-weight: 800;
    letter-spacing: 0.04em;
  }

  .brand-text {
    font-size: 1.25rem;
    font-weight: 700;
    color: $heading-color;
  }
  
  .brand-subtitle {
    font-size: 0.78rem;
    color: $text-muted;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
}

// Override Bootstrap navbar styles for better contrast
.navbar-light .navbar-nav .nav-link {
  color: $text-color !important;
  font-weight: 600;
  margin: 0 0.5rem;
  padding: 0.5rem;
  position: relative;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 2px;
    background: $primary-gradient;
    transition: width 0.3s ease;
  }
  
  &:hover, &:focus {
    color: $accent-color !important;
    
    &::after {
      width: 80%;
    }
  }
  
  &.active, &.router-link-active, &.router-link-exact-active {
    color: $accent-color !important;
    font-weight: 700;
    
    &::after {
      width: 80%;
    }
  }
}

// Mobile toggle button styling
.navbar-light .navbar-toggler {
  border-color: rgba($accent-color, 0.12);
  
  .navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2824, 35, 47, 0.85%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  }
  
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba($accent-color, 0.25);
  }
}

.nav-cta {
  margin-left: 1.5rem;
}

.contact-button {
  background: $accent-color;
  border: none;
  color: #ffffff;
  padding: 0.6rem 1.5rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 28px rgba($accent-color, 0.16);
    text-decoration: none;
    color: #ffffff;
  }
}

// Ensure proper contrast ratios for WCAG compliance
@media (prefers-contrast: high) {
  .modern-navbar {
    background: rgba(255, 255, 255, 1) !important;
    border-bottom: 2px solid $heading-color;
  }
  
  .navbar-light .navbar-nav .nav-link {
    color: $heading-color !important;
    font-weight: 700;
  }
}

// Mobile responsive adjustments
@media (max-width: 991px) {
  .modern-navbar {
    padding: 0.75rem 0;
  }
  
  .navbar-light .navbar-nav .nav-link {
    padding: 0.75rem 0.5rem;
    margin: 0;
    border-bottom: 1px solid rgba($accent-color, 0.1);
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  .nav-cta {
    margin-left: 0;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid rgba($accent-color, 0.1);
  }
  
  .contact-button {
    display: block;
    text-align: center;
    width: 100%;
  }
}
</style>
